export default{
    ordenes:[],
    historico:[],
    isOk: false,
    error:null,
    errorMessage:'',

}